/**
 * AppMenuIcon React component
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


 // React
import React from 'react';
import {connect} from "react-redux";

// Material-UI
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from "@material-ui/core/Menu/Menu";
import Divider from '@material-ui/core/Divider';

// application
import {openPageAction} from "../../redux/view/actions";
import {ABOUT_PAGE} from "../../redux/view/consts";
import {editObject} from "../../operations/editing";
import {openControlPage, openAdminPage} from "../../operations/administration";
import {openUserAccountPage} from "../../operations/useraccount";
import {logout} from "../../operations/login";


class AppMenuIcon extends React.Component {

    state = {
        anchorElement: null
    };

    open(anchorElement) {
        this.setState({anchorElement: anchorElement});
    };

    close() {
        this.setState({anchorElement: null});
    };

    render() {

        const {variant} = this.props;

        // the mobile variant combines the other variants
        const isMobileVariant = variant === "mobile";
        const isDashboardVaraint = isMobileVariant || variant === "dashboard";
        const isProfileVaraint = isMobileVariant || variant === "profile";

        const closeAnd = (operation) => () => {
            this.close();
            operation();
        }

        return <>
            <IconButton
                aria-haspopup="true"
                onClick={event => this.open(event.currentTarget)}
                color="inherit"
            >
                {this.props.icon}
            </IconButton>
            <Menu 
                anchorEl={this.state.anchorElement}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                open={Boolean(this.state.anchorElement)}
                onClose={() => this.close()}
            >
                {
                    isProfileVaraint && <MenuItem disabled={true}>{this.props.userName}</MenuItem>
                }
                {
                    isProfileVaraint && <Divider/>
                }
                {
                    isProfileVaraint && <MenuItem onClick={closeAnd(this.props.openUserAccountPage)}>
                        Mein Account
                    </MenuItem>
                }
                {
                    isProfileVaraint && this.props.userSettingsObjectId && <MenuItem onClick={closeAnd(() => this.props.editObject(this.props.userSettingsObjectId))}>
                        Meine Einstellungen
                    </MenuItem>
                }
                {
                    isMobileVariant && <Divider/>
                }
                {
                    isDashboardVaraint && this.props.canOpenControlDashboard && <MenuItem onClick={closeAnd(this.props.openControlPage)}>
                        Kontrollzentrum
                    </MenuItem>
                }
                {
                    isDashboardVaraint && this.props.canOpenAdminDashboard && <MenuItem onClick={closeAnd(this.props.openAdminPage)}>
                        Admin-Dashboard
                    </MenuItem>
                }
                {
                    isDashboardVaraint && this.props.canEditConfiguration && <MenuItem onClick={closeAnd(() => this.props.editObject("configuration.active"))}>
                        Konfiguration
                    </MenuItem>
                }
                {
                    isDashboardVaraint && <MenuItem onClick={closeAnd(() => this.props.openPageAction(ABOUT_PAGE))}>Info</MenuItem>
                }
                {
                    isProfileVaraint && <Divider/>
                }
                {
                    isProfileVaraint && <MenuItem onClick={closeAnd(this.props.logout)}>Logout</MenuItem>
                }
            </Menu>
        </>;
    }
}

const mapStateToProps = state => {

    const privileges = state.authorization.userPrivileges;

    return {
        userName: state.authorization.userInfo ? state.authorization.userInfo.name : undefined,
        userSettingsObjectId: state.configuration.userSettings && state.configuration.userSettings.id,
        canOpenControlDashboard: privileges.openControlDashboard,
        canOpenAdminDashboard: privileges.openAdminDashboard || privileges.exportDatabase,
        canEditConfiguration: privileges.editConfiguration
    }
};

export default connect(mapStateToProps, {
    openControlPage,
    openAdminPage,
    openUserAccountPage,
    editObject,
    openPageAction,
    logout
})(AppMenuIcon);